<template>
  <div class="w-100 h-100">
    <router-view />

    <contact-view
      v-if="showContactInfo"
      :contact="currentContact"
      @exit="hideContact"
    />

    <toast-message
      v-if="isToastShowing"
      :icon-left="toastIconLeft"
      :static="true"
      :icon-right="toastIconRight"
      :text="toastText"
    />
  </div>
</template>

<script>
import app from '@/app/app';
export default {
  components: {},
  extends: app
};
</script>

<style lang="scss" scoped>

</style>
